import { Injectable } from '@angular/core';
import { LZStringService } from '../l-z-string/l-z-string.service';
import { LocalStorageCommonService } from './local-storage-common.service';
import { from, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageDisclaimerService {
    public constructor(
        private readonly localStorageCommonService: LocalStorageCommonService,
        private readonly LZString: LZStringService,
    ) {}

    public saveDisclaimerToLocalStorage(id: string, disclaimer: string): Observable<void> {
        const compressed = this.LZString.compress(disclaimer);
        return from(this.localStorageCommonService.storageSetAsync(id, compressed));
    }

    public async getDisclaimerFromLocalStorageAsync(id: string): Promise<string> {
        return this.localStorageCommonService.storageGetAsync<string>(id).then((compressed) => {
            if (compressed) {
                return this.LZString.decompress(compressed);
            } else {
                return '';
            }
        });
    }
}
